import React from 'react';
import { withRouter } from 'react-router-dom';

import { SubscriptionList } from 'components/Subscriptions';
import Layout from 'components/Layout';
import i18n from 'i18n-js';

const SubscriptionsList = ({ history }) => {
  return (
    <Layout title={i18n.t('subscriptions.title')}>
      <SubscriptionList type="customer" history={history} title={i18n.t('subscriptions.title')} />
    </Layout>
  );
};

export default withRouter(SubscriptionsList);
